module.exports = ".table-input .form-group{\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main